import { memo } from "react";
const genericMemo = memo;
export default genericMemo;
